(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionLine', PharmaReceptionLine);

	PharmaReceptionLine.$inject = [ '$resource' ];

	function PharmaReceptionLine($resource) {
		var resourceUrl = 'api/pharma-reception-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
